import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../common/state';
import { closeAdvancedModal } from '../../state/advanced/toggle_modal';
import { Advanced } from './index';

export const AdvancedContainer = connect(
  (state: IAppState) => {
    const {
      config,
      filters: { jsonQuery, currentLocation },
    } = state;

    return { jsonQuery, currentLocation, config };
  },
  (dispatch: Dispatch) => ({
    close: () => {
      dispatch(closeAdvancedModal());
    },
  }),
)(Advanced);
